import React from 'react'

const MainBanner = () => {
    return (
        <>
            <div className="banner-box">
                <div className="container h-100">
                    <div className="row h-100">
                        <div className="col-md-12 h-100">
                            <div className="banner-text h-100">
                                <img src="/images/crop-png.png" className='me-3' width={'70px'} alt="" />
                                <div className="banner-text-icon">
                                    <h1>I-Sit Corp Pro</h1>
                                    <p>Get Start with I-Set Corporate User <i className="fas fa-exclamation exclamation-icon"></i>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default MainBanner